import { ENV } from '../../environment';

type Config = {
  apiKey: string;
  sdkEndpoint: string;
};
const DevEnv: Config = {
  apiKey: '8818ebc3-d57a-4c8f-aa18-7d928ec2f98c',
  sdkEndpoint: 'sdk.iad-05.braze.com',
};
const StagingEnv: Config = {
  apiKey: '27a5cf56-4880-4359-833d-cfc520d4e4fc',
  sdkEndpoint: 'sdk.iad-05.braze.com',
};
const ProdEnv: Config = {
  apiKey: '658ec41a-6d7a-46ae-86dd-4cd2aaf4dfc0',
  sdkEndpoint: 'sdk.iad-05.braze.com',
};
export const config: Config = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
